import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';

import { GenericValue, DynamicComponent } from 'hisng';

import { ResearchPartnerSimple } from 'app/fs/res/common/model/researchPartner/researchPartner';
import { ResearchInfrastructureOrganisation } from 'app/fs/res/research-infrastructure/model/research-infrastructure-classes';

@Component( {
    selector: 'res-research-infrastructure-members-select',
    templateUrl: './research-infrastructure-members-select.component.html',
} )

export class ResearchInfrastructureMemberSelectComponent implements OnChanges {
    @Input() organisations: ResearchInfrastructureOrganisation[];
    @Input() dynamicComponent: DynamicComponent;
    @Input() isCoordinator: boolean;
    @Input() singleSelect: boolean;
    @Input() hisDdKey: string;
    @Input() assignLink: string;
    @Input() noAssignedMessage: string;
    @Output() organisationsChange: EventEmitter<ResearchInfrastructureOrganisation[]> = new EventEmitter();

    public internalOrganisations: GenericValue[];
    public externalOrganisations: ResearchPartnerSimple[];

    ngOnChanges( cahnges: SimpleChanges ) {
        if ( cahnges.organisations ) {
            this.fillArrays();
        }
    }

    private fillArrays() {
        this.internalOrganisations = [];
        this.externalOrganisations = [];

        this.organisations.forEach( o => {
            if ( o.researchPartner ) {
                this.externalOrganisations.push( o.researchPartner );
            } else if ( o.orgunit ) {
                this.internalOrganisations.push( o.orgunit );
            }
        } );
    }

    public deleteOrganizationChange( value: GenericValue | ResearchPartnerSimple ) {
        let index = this.organisations.findIndex( o => o.orgunit && o.orgunit.id === value.id
            || o.researchPartner && o.researchPartner.id === value.id );

        if ( index > -1 ) {
            this.organisations.splice( index, 1 );
        }
        this.organisationsChange.emit( this.organisations );
    }

    /* call back method implementation for internal organizations */
    public selectedInternalOrgUnitChange( event: GenericValue[] ): void {
        this.organisations = this.organisations.filter( o => o.orgunit == null); // filter internal orgunits
        event.forEach( ( e: GenericValue ) => {
            let index = this.organisations.findIndex( o => o.orgunit && o.orgunit.id === e.id );
            if ( index < 0 ) {
                let orgUnit = new ResearchInfrastructureOrganisation( e, null, this.isCoordinator );
                this.organisations = [...this.organisations, orgUnit];
            }
        } );
        this.organisationsChange.emit( this.organisations );
    }

    /* call back method implementation for external organizations */
    public selectedExternalOrgUnitChange( event: ResearchPartnerSimple[] ): void {
        event.forEach( ( e: ResearchPartnerSimple ) => {
            let index = this.organisations.findIndex( o => o.researchPartner && o.researchPartner.id === e.id );
            if ( index < 0 ) {
                let orgUnit = new ResearchInfrastructureOrganisation( null, e, this.isCoordinator );
                this.organisations = [...this.organisations, orgUnit];
            }
        } );
        this.organisationsChange.emit( this.organisations );
    }
}
